(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["support-faq"] && !Shopify.designMode) return;
  try {
    
  function toggleFaq(element) {
    const allFaqs = document.querySelectorAll('.faq-item');
    allFaqs.forEach((item) => {
      if (item !== element && item.classList.contains('open')) {
        item.classList.remove('open');
      }
    });
    element.classList.toggle('open');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-page"] && !Shopify.designMode) return;
  try {
    
  // Filter functionality for testimonials page
  document.addEventListener('DOMContentLoaded', function () {
    const filterTabs = document.querySelectorAll('.testimonials-page-filter .filter-tab');
    const testimonialCards = document.querySelectorAll('.testimonials-page-card');

    filterTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        // Update active tab
        filterTabs.forEach((t) => t.classList.remove('active'));
        tab.classList.add('active');

        const filter = tab.dataset.filter;

        // Filter cards with animation reset
        testimonialCards.forEach((card, index) => {
          if (filter === 'all' || card.dataset.product === filter) {
            card.style.display = 'flex';
            // Re-trigger animation
            card.classList.remove('animate-in');
            setTimeout(() => {
              card.style.transitionDelay = `${index * 50}ms`;
              card.classList.add('animate-in');
            }, 50);
          } else {
            card.style.display = 'none';
          }
        });
      });
    });

    // Scroll animation observer with staggered delays
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    let cardIndex = 0;
    const cardObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const card = entry.target;
          // Staggered delay based on visible order
          card.style.transitionDelay = `${cardIndex * 80}ms`;
          card.classList.add('animate-in');
          cardIndex++;
          cardObserver.unobserve(card);
        }
      });
    }, observerOptions);

    testimonialCards.forEach(card => cardObserver.observe(card));
  });

  } catch(e) { console.error(e); }
})();
})();
